export default __webpack_public_path__ + "static/media/early-payments-startup.bb1eeaa5.png";